import React from 'react';

const AmountContainer = () => {
  return (
    <div className='h-[10mm] mt-[2mm] text-xs border-[3px] border-black mb-[4mm]'>
      <div className='grid grid-cols-[12mm_24mm_18mm_28mm_12mm_26mm_12mm_26mm_12mm_26mm] gap-[1px] h-full'>
        <div className='w_center r_border'>수량</div>
        <div className='flex items-center r_border'>
          <span className='ml-auto mr-2'>600</span>
        </div>
        <div className='w_center r_border'>공급가액</div>
        <div className='flex items-center r_border'>
          <span className='ml-auto mr-2'>120,000</span>
        </div>
        <div className='w_center r_border'>VAT</div>
        <div className='flex items-center r_border'>
          <span className='ml-auto mr-2'>120,000</span>
        </div>
        <div className='w_center border-r border-black'>합계</div>
        <div className='flex items-center r_border'>
          <span className='ml-auto mr-2'>132,000</span>
        </div>
        <div className='w_center border-r border-black'>인수</div>
        <div className='flex items-center'>
          <span className='ml-auto mr-2'>인</span>
        </div>
      </div>
    </div>
  );
};

export default AmountContainer;
